"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.LocationSubCategory = (0, type_utils_1.makeEnum)({
    /** Fallback subcategory */
    Location: 'LOCATION',
});
//# sourceMappingURL=location.js.map